const CATEGORY_ICON_NAMES = [
    'dog',
    'cat',
    'bird',
    'rabbit',
    '信用卡',
    '唱歌话筒',
    '彩票',
    '投资',
    '比特币',
    '珍珠奶茶',
    '钻石',
    '储蓄',
]
export default CATEGORY_ICON_NAMES;